import { useEffect, useMemo } from 'react'
import { DataPlayer } from 'player'
import { Task } from '../../../../types'
import { useStorePlayer } from '../store'
import { useDataMetadata } from './use-data-metadata'
import { UseChangeOperations } from '../../../../hooks/tasks/use-upgradability-new/use-change-operations'
import { useDataPosts } from './use-data-posts'

interface UseDataProps {
  task: Task
  changeOperations: UseChangeOperations
}

export const useData = ({ task }: UseDataProps): DataPlayer => {
  const { data, setData } = useStorePlayer()

  useDataPosts({
    task
  })

  useDataMetadata({
    task
  })
  const { isDemo } = task

  const filename = useMemo(() => task.file?.name, [task.file?.name])

  const song = useMemo(
    () => task?.summary?.v1?.original?.title,
    [task?.summary]
  )

  const cover = useMemo(
    () => task?.summary?.v1?.original?.cover,
    [task?.summary]
  )

  useEffect(() => {
    setData({
      filename,
      infoTrack: undefined,
      isDemo,
      song,
      cover
    })
  }, [filename, setData, isDemo, song, cover])

  return data
}
